'use client'

import type { ReactNode } from 'react'

import Link from 'next/link'

import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'

/**
 * Дугуй товч — hover дээр дүүргэлт нь дотроосоо тэлж гарна.
 *
 * `shadcn-nextjs-craft-landing-page-2.0.0` (бүрэн лицензтэй) загварын
 * `craft-button`-оос ХУУЛЖ авав.
 *
 * ⚠️ Ганц ялгаа: тэр загварын `Button` нь `asChild`-тай Radix, энэ сайтынх
 * нь base-ui бөгөөд `render` + `nativeButton={false}`-оор холбоос болдог.
 * Тиймээс `asChild`-ийн оронд `href` авдаг болгов.
 */
export const CraftButtonLabel = ({ children, className }: { children: ReactNode; className?: string }) => (
  <span className={cn('group-hover/button:text-foreground relative z-2 transition-colors duration-500', className)}>
    {children}
  </span>
)

export const CraftButtonIcon = ({ children, className }: { children: ReactNode; className?: string }) => (
  <span className={cn('relative z-1 size-5', className)}>
    <span className='bg-background absolute inset-0 -z-1 size-5 rounded-full transition-transform duration-500 group-hover/button:scale-[15]' />
    <span className='bg-background text-primary group-hover/button:bg-primary group-hover/button:text-background relative z-2 flex size-5 items-center justify-center rounded-full transition-all duration-500'>
      {children}
    </span>
  </span>
)

const CRAFT_BUTTON =
  'group/button hover:bg-background dark:hover:border-primary/30 h-11 cursor-pointer gap-2 overflow-hidden rounded-full border-0 px-5! text-lg duration-500 hover:shadow-md active:translate-y-0 dark:border dark:border-transparent'

export const CraftButton = ({
  children,
  className,
  href
}: {
  children: ReactNode
  className?: string
  href: string
}) => (
  <Button className={cn(CRAFT_BUTTON, className)} render={<Link href={href} />} nativeButton={false}>
    {children}
  </Button>
)
